import {
  WEBCODE_NORESULT,
  WEBCODE_REQUESTED,
  WEBCODE_SKIP,
  WEBCODE_SUCCESS,
} from "actions/const";
import config from "config";
import { UrlUtils } from "utils/url";

function reducer(state = config.state.webcode, action) {
  switch (action.type) {
    case WEBCODE_NORESULT:
      return { ...state, noResultTerm: action.noResultTerm };

    case WEBCODE_REQUESTED:
      return { ...state, loading: true };

    case WEBCODE_SKIP:
      return { ...state, loading: false };

    case WEBCODE_SUCCESS:
      const targetUrl = action.targetUrl;

      if (targetUrl) {
        UrlUtils.redirect(targetUrl);
      }

      return { ...state, loading: false };

    default:
      return state;
  }
}
export default reducer;
